export const PROFILE_INBOUND_EMAIL_OPEN_EVENT = 'captureez:profile-inbound-email-open';

export const requestProfileInboundEmailOpen = (childId = '') => {
  if (typeof window === 'undefined' || !childId) return;
  window.dispatchEvent(new CustomEvent(PROFILE_INBOUND_EMAIL_OPEN_EVENT, {
    detail: { childId },
  }));
};
